export interface SeasonActions {
  /** «Забрать всё» в окне сезона. */
  claimSeason(): void;
}

const noop = () => {};

export const defaults: SeasonActions = {
  claimSeason: noop,
};

declare module "../actions" {
  interface WindowActions extends SeasonActions {}
}
